<style lang="scss" scoped>
    .loading-wrapper {
        min-height: 64px;
    }
</style>

<template>
    <div>
        <base-dialog
            v-model="isScalingOptionsModalOpen"
            :min-width="800"
            :max-width="800"
            :on-save="updateSCUScaleOptions"
            :on-close="resetService"
            :on-cancel="resetService">
            <template #title>
                <p class="font-weight-regular text-h5 ma-0">
                    {{ $t('scaleSCU') }}
                </p>
            </template>
            <template #body>
                <div
                    v-if="isFetchingLimit"
                    class="ml-3 mt-8 loading-wrapper d-flex align-center justify-center">
                    <v-progress-circular
                        size="40"
                        width="7"
                        indeterminate />
                </div>
                <div
                    v-else
                    class="ml-3 mt-8">
                    <div class="my-2 d-flex align-center">
                        <div class="text-body-2 font-weight-medium mr-2">
                            {{ $t('launchService.scuScaling') }}
                        </div>
                        <HelpToolTip>
                            <template #message>
                                <p>
                                    {{ $t('launchService.scuScaleInfo') }}
                                </p>
                            </template>
                        </HelpToolTip>
                    </div>
                    <v-range-slider
                        v-model="cpuScale"
                        :min="limits[0] || 0"
                        :max="limits[1] || 0"
                        hide-details>
                        <template #prepend>
                            <div
                                class="pt-1 text-body-2"
                                style="white-space: nowrap;">
                                <span class="font-weight-bold">Min:</span> {{ cpuScale[0] }} SCUs
                            </div>
                        </template>
                        <template #append>
                            <div
                                class="text-body-2"
                                style="white-space: nowrap;">
                                <span class="font-weight-bold">Max:</span> {{ cpuScale[1] }} SCUs
                            </div>
                        </template>
                    </v-range-slider>
                </div>
            </template>
            <template #actions="{ cancel, save }">
                <v-spacer />
                <v-btn
                    color="primary"
                    depressed
                    rounded
                    outlined
                    class="cancel"
                    @click="cancel">
                    <span class="text-none">{{ $t('cancel') }} </span>
                </v-btn>
                <v-btn
                    color="primary"
                    depressed
                    rounded
                    :loading="updateInProgress"
                    :disabled="isFetchingLimit || isApplyDisabled"
                    @click="save">
                    <span class="text-none"> {{ $t('applyChanges') }}</span>
                </v-btn>
            </template>
        </base-dialog>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import to from 'await-to-js'
    import HelpToolTip from 'components/common/HelpTooltip'
    import { getTopologyOptions } from 'services/offerings'

    export default {
        name: 'ScaliningOptionsModal',
        components: { HelpToolTip, },
        data() {
            return {
                cpuScale: [],
                limits: [],
                updateInProgress: false,
                isFetchingLimit: false,
            }
        },
        computed: {
            ...mapState(['manageServices']),
            ...mapGetters(['getServiceById']),
            service() {
                return this.getServiceById(this.manageServices.serviceId)
            },
            serviceId() {
                return this.service.id
            },
            isScalingOptionsModalOpen: {
                get() {
                    return this.manageServices.isScalingOptionsOpen
                },
                set(value) {
                    this.setScalingOptionsDialog(value)
                },
            },
            serviceScaleOptions() {
                return this.service?.scale_options || null
            },
            isApplyDisabled() {
                return this.cpuScale[0] === this.serviceScaleOptions?.min_compute &&
                    this.cpuScale[1] === this.serviceScaleOptions?.max_compute
            },
        },
        watch: {
            service(newVal, oldVal) {
                if (!newVal || newVal?.id === oldVal?.id) return
                this.cpuScale =
                    this.serviceScaleOptions ?
                        [this.serviceScaleOptions.min_compute, this.serviceScaleOptions.max_compute] :
                        []
                this.checkAdditionalOptions()
            },
        },
        methods: {
            ...mapMutations(['setScalingOptionsDialog']),
            ...mapActions(['openScalingOptionstModal', 'scaleSCUOptions']),
            async checkAdditionalOptions() {
                this.isFetchingLimit = true

                const [error, response] = await to(getTopologyOptions(this.service?.topology))
                this.limits = this.cpuScale || []
                if (error || !response || !response.scale_options) {
                    this.isFetchingLimit = false
                    return
                } else {
                    this.limits = [
                        response.scale_options.cpu?.range[0],
                        response.scale_options.cpu?.range[1]
                    ]
                }

                this.isFetchingLimit = false
            },
            async updateSCUScaleOptions() {
                this.updateInProgress = true
                await this.scaleSCUOptions({
                    serviceId: this.serviceId,
                    scuValues: {
                        'min_compute': this.cpuScale[0],
                        'max_compute': this.cpuScale[1],
                    },
                })
                this.resetService()
            },
            resetService() {
                this.cpuScale = []
                this.updateInProgress = false
                this.openScalingOptionstModal({ popupState: false, serviceId: null, })
            },
        },
    }
</script>
